import { Action } from '@ngrx/store'
import * as organizationsTypes from './organizations.types'
import { Organization } from './organizations.interface'

export class FetchOrganizationsRequest implements Action {
  readonly type = organizationsTypes.FETCH_ORGANIZATIONS_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchOrganizationsSuccess implements Action {
  readonly type = organizationsTypes.FETCH_ORGANIZATIONS_SUCCESS
  constructor(
    public payload: Organization[],
    public total: number,
    public results: number,
  ) {}
}

export class FetchOrganizationsFailure implements Action {
  readonly type = organizationsTypes.FETCH_ORGANIZATIONS_FAILURE
  constructor(public payload: any) {}
}

export class FetchOrganizationRequest implements Action {
  readonly type = organizationsTypes.FETCH_ORGANIZATION_REQUEST
  constructor(public id: number) {}
}

export class FetchOrganizationSuccess implements Action {
  readonly type = organizationsTypes.FETCH_ORGANIZATION_SUCCESS
  constructor(public payload: Organization) {}
}

export class FetchOrganizationFailure implements Action {
  readonly type = organizationsTypes.FETCH_ORGANIZATION_FAILURE
  constructor(public payload: any) {}
}

export class DeleteOrganizationRequest implements Action {
  readonly type = organizationsTypes.DELETE_ORGANIZATION_REQUEST
  constructor(public id: number) {}
}

export class DeleteOrganizationSuccess implements Action {
  readonly type = organizationsTypes.DELETE_ORGANIZATION_SUCCESS
  constructor() {}
}

export class DeleteOrganizationFailure implements Action {
  readonly type = organizationsTypes.DELETE_ORGANIZATION_FAILURE
  constructor(public payload: any) {}
}

export class CreateOrganizationRequest implements Action {
  readonly type = organizationsTypes.CREATE_ORGANIZATION_REQUEST
  constructor(public payload) {}
}

export class CreateOrganizationSuccess implements Action {
  readonly type = organizationsTypes.CREATE_ORGANIZATION_SUCCESS
  constructor() {}
}

export class CreateOrganizationFailure implements Action {
  readonly type = organizationsTypes.CREATE_ORGANIZATION_FAILURE
  constructor(public payload: any) {}
}

export class UpdateOrganizationRequest implements Action {
  readonly type = organizationsTypes.UPDATE_ORGANIZATION_REQUEST
  constructor(public id: number, public payload) {}
}

export class UpdateOrganizationSuccess implements Action {
  readonly type = organizationsTypes.UPDATE_ORGANIZATION_SUCCESS
  constructor() {}
}

export class UpdateOrganizationFailure implements Action {
  readonly type = organizationsTypes.UPDATE_ORGANIZATION_FAILURE
  constructor(public payload: any) {}
}

// Common

export class UpdateField implements Action {
  readonly type = organizationsTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = organizationsTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdateOrganizationRequest
  | UpdateOrganizationSuccess
  | UpdateOrganizationFailure
  | FetchOrganizationsSuccess
  | FetchOrganizationsFailure
  | FetchOrganizationsRequest
  | FetchOrganizationSuccess
  | FetchOrganizationFailure
  | FetchOrganizationRequest
  | CreateOrganizationRequest
  | CreateOrganizationSuccess
  | CreateOrganizationFailure
  | DeleteOrganizationRequest
  | DeleteOrganizationSuccess
  | DeleteOrganizationFailure
  | SetDefaultData
  | UpdateField
  | FetchOrganizationsRequest
  | FetchOrganizationsSuccess
  | FetchOrganizationsFailure
